import { useQuery } from "@tanstack/react-query";
import { erp } from "@/lib/erp";
import type { Item } from "@/lib/erp";
import { getQueryOptions } from "@/lib/config/queryConfig";
import { itemQueryKeys } from "./itemQueryKeys";

/**
 * Hook for fetching a single item detail
 * 
 * @param name - Item name/code
 * @returns React Query result with item data
 */
export function useItemDetail(name: string) {
  return useQuery<Item>({
    queryKey: itemQueryKeys.detail(name),
    queryFn: () => erp.items.detail(name),
    enabled: !!name,
    ...getQueryOptions("detail"),
  });
}

